import { PublicationShortname } from "@src/app/auth/serviceIdentifier";
import cx from "classnames";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";

type Props = {
  theme: PublicationShortname | null;
  onSubscribe: () => void;
  onLogin: () => void;
  // The "Already a subscriber? Log in" link is anonymous-only. A logged-in
  // non-subscriber (registered) is already signed in, so the design drops it
  // for that state and shows the subscribe CTA alone (Figma: registered bottom
  // bar 9466:51286 vs anon 9174:38074).
  showLogin?: boolean;
};

/**
 * Sticky bottom bar shown on the preview Index for non-subscribers
 * (EPPR2-3142). Outlined "Learn about subscription" CTA plus (for anonymous
 * users only) a "Log in" text link for returning subscribers. Design: Figma
 * "E-Paper Preview Pilot with TM — Website".
 */
export default function PreviewBottomBar({
  theme,
  onSubscribe,
  onLogin,
  showLogin = true,
}: Props): ReactElement {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.bottomBar)} data-theme={theme ?? undefined}>
      <button className={cx(styles.subscribe)} onClick={onSubscribe}>
        {t("home:preview.bottomBar.subscribe")}
      </button>
      {showLogin && (
        <button className={cx(styles.login)} onClick={onLogin}>
          {t("home:preview.bottomBar.login")}
        </button>
      )}
    </div>
  );
}
